import React, { createContext, useState, useEffect } from "react";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [uploadStatus, setUploadStatus] = useState(
    localStorage.getItem("uploadStatus") || "idle"
  );
  const [alertMessage, setAlertMessage] = useState(
    localStorage.getItem("alertMessage") || ""
  );

  const [batchRefreshKey, setBatchRefreshKey] = useState(0);

  // keep in sync with localStorage
  useEffect(() => {
    localStorage.setItem("uploadStatus", uploadStatus);
  }, [uploadStatus]);

  useEffect(() => {
    localStorage.setItem("alertMessage", alertMessage);
  }, [alertMessage]);

  // listen for cross-tab changes
  useEffect(() => {
    const handleStorage = (e) => {
      if (e.key === "uploadStatus") setUploadStatus(e.newValue);
      if (e.key === "alertMessage") setAlertMessage(e.newValue);
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  const triggerGlobalAlert = (msg) => {
    setAlertMessage(msg);
    localStorage.setItem("alertMessage", msg);
  };

  const clearGlobalAlert = () => {
    setAlertMessage("");
    localStorage.removeItem("alertMessage");
  };

  // 👇 new function for triggering re-fetch in results page
  const triggerBatchRefresh = () => setBatchRefreshKey(prev => prev + 1);

  return (
    <AppContext.Provider
      value={{
        uploadStatus,
        setUploadStatus,
        alertMessage,
        triggerGlobalAlert,
        clearGlobalAlert,
        batchRefreshKey,
        triggerBatchRefresh
      }}
    >
      {children}
    </AppContext.Provider>
  );
};